import { render, staticRenderFns } from "./ResolveCaseOfficer.vue?vue&type=template&id=fd01b5fc"
import script from "./ResolveCaseOfficer.vue?vue&type=script&lang=js"
export * from "./ResolveCaseOfficer.vue?vue&type=script&lang=js"
import style0 from "./ResolveCaseOfficer.vue?vue&type=style&index=0&id=fd01b5fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports